import * as React from "react";
import { SchedulerForm } from "@progress/kendo-react-scheduler";
import CustomFormEditor from '@/components/kendo/scheduler/custom-form-editor';
import CustomDialog from '@/components/kendo/scheduler/custom-dialog';

export default function CustomForm(props: any) {

    const formValidator = (_dataItem: any, formValueGetter: any) => {
        let result = {};
        //   .filter(Boolean)
        //   .reduce((current, acc) => current || acc, "");
        //   .filter(Boolean)
        //   .reduce((current, acc) => current || acc, "");
        return result;
    };

    return (
        <SchedulerForm
          {...props}
          editor={CustomFormEditor}
          dialog={CustomDialog}
          validator={formValidator}
        />
    );
};
